import { AcceptWaiverAgreement, AcceptWaiverAgreementVariables } from "_graphql/mutation/__generated__/AcceptWaiverAgreement";
import { Modal, OfficeButton } from "components";
import { setMe, useCurrentUser } from "_graphql/cache/auth";

import { AcceptTermsOfAgreement } from "components/forms";
import { LocationGenerics } from "router/location";
import { acceptWaiverAgreement } from "_graphql/visal/mutations/offers";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMatch } from "react-location";
import { useMutation } from "@apollo/client";
import { useOffer } from "hooks/data/use-offers";
import { wrapClick } from "utils";

export default function AcceptAgreementContainer({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
}) {
    const currentUser = useCurrentUser()
    const { params } = useMatch<LocationGenerics>();

    const [agree, { loading }] = useMutation<AcceptWaiverAgreement, AcceptWaiverAgreementVariables>(acceptWaiverAgreement, {
        onCompleted: () => {
            setMe(Object.assign({}, currentUser, {
                employee: Object.assign({}, currentUser?.employee, {
                    accept_waiver_aggreement: true,
                }),
            }));
            toast.success("You have successfully accepted the terms of agreement and waiver of liability.");
            setOpen(false);
        },
        variables: {
            status: true,
        },
    })

    const { loading: loadingOffer } = useOffer({
        offer_id: params?.offer || "",
    });



    const form = useFormik<any>({
        initialValues: {
            termsAccepted: false,
            waiverAccepted: false,
        },
        onSubmit: () => {
            if (!currentUser?.employee?.accept_waiver_aggreement) {
                agree().catch((error) => {
                    console.error("Error accepting waiver agreement:", error);
                    toast.error("Failed to accept the terms of agreement and waiver of liability. Please try again.");
                });
            } else {
                toast.error("You have already accepted the terms of agreement and waiver of liability.");
            }
        },
        onReset: () => {
            setOpen(false);
        },
    });


    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title={`Accept Terms of Agreement and Waiver Liability`}
            loading={loadingOffer}
            description={`Please review the terms of agreement and waiver of liability before accepting. Ensure you understand the implications of your acceptance.`}
            renderActions={() => (
                <>
                    <OfficeButton loading={loading} size="sm" onClick={wrapClick(form.handleSubmit)} disabled={!form.values.termsAccepted || !form.values.waiverAccepted}>
                        {loading ? "Accepting..." : "Accept"}
                    </OfficeButton>
                </>
            )}
        >
            <AcceptTermsOfAgreement form={form} />
        </Modal>
    );
}
